<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function showOwnItemImages(value: boolean) {
  await settingsStore.set('showOwnItemImages', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.showOwnItemImages"
    :label="t('settings.materials.showOwnItemImages')"
    :description="t('settings.materials.showOwnItemImagesDescription')"
    @change="showOwnItemImages"
  />
</template>
